export default "__VITE_ASSET__6yrOyaXI__"